<script>
    import { Breadcrumb, BreadcrumbItem } from '@sveltestrap/sveltestrap';
</script>
<Breadcrumb>
    <BreadcrumbItem>
        <a href="/">
            Home
        </a>
    </BreadcrumbItem>    
    <BreadcrumbItem active>
        Kitchen Sink
    </BreadcrumbItem>
</Breadcrumb>

<h1 class='text-center'>
    Bootstrap Kitchen Sink
</h1>

<div class='row bg-white'>
    <div class='col-sm-12 col-md-6'>                

        <h1>
            Headings
        </h1>

        <h1>
            Heading One
        </h1>

        <h2>
            Heading Two
        </h2>

        <h3>
            Heading Three
        </h3>

        <h4>
            Heading Four
        </h4>

        <h5>
            Heading Five
        </h5>

        <h6>
            Heading Six
        </h6>

        <hr/>

        <h1>
            Text
        </h1>

        <p>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-primary'>
            Primary
        </h6>
        <p class='text-primary'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-success'>
            Success
        </h6>
        <p class='text-success'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-info'>
            Info
        </h6>
        <p class='text-info'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-warning'>
            Warning
        </h6>
        <p class='text-warning'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-danger'>
            Danger
        </h6>
        <p class='text-danger'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

         <h6 class='text-secondary'>
            Secondary
        </h6>
        <p class='text-secondary'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-light'>
            Light
        </h6>
        <p class='text-light'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

        <h6 class='text-dark'>
            Dark
        </h6>
        <p class='text-dark'>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        </p>

    </div>
    <div class='col-sm-12 col-md-6'>
        <h1>
            Buttons
        </h1>
        <div class='row mb-3'>
            <div class='col-sm-4'>
                
                <button type='button' class='btn btn-primary btn-sm'>
                    Small
                </button>
                
            </div>
            <div class='col-sm-4'>
                
                <button type='button' class='btn btn-primary'>
                    Standard
                </button>
                
            </div>
            <div class='col-sm-4'>
                
                <button type='button' class='btn btn-primary btn-lg'>
                    Large
                </button>
                
            </div>            
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-primary'>
                        Primary
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-primary'>
                        Primary Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-primary' disabled>
                        Primary disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-success'>
                        Success
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-success'>
                        Success Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-success' disabled>
                        Success disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-info'>
                        Info
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-info'>
                        Info Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-info' disabled>
                        Info disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-warning'>
                        Warning
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-warning'>
                        Warning Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-warning' disabled>
                        Warning disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-danger'>
                        Danger
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-danger'>
                        Danger Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-danger' disabled>
                        Danger disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-secondary'>
                        Secondary
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-secondary'>
                        Secondary Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-secondary' disabled>
                        Secondary disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-light'>
                        Light
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-light'>
                        Light Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-light' disabled>
                        Light disabled
                    </button>
                </div>
            </div>
        </div>

        <div class='row mb-3'>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-dark'>
                        Dark
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-outline-dark'>
                        Dark Outline
                    </button>
                </div>
            </div>
            <div class='col-sm-4'>
                <div class='d-grid'>
                    <button type='button' class='btn btn-dark' disabled>
                        Dark disabled
                    </button>
                </div>
            </div>
        </div>

        <hr/>

        <h1>
            Cards
        </h1>

        <div class='card mb-3'>
            <div class='card-header'>
                Header
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>
            <div class='card-footer'>
                Footer
            </div>
        </div>

        <div class='card mb-3 border-primary'>
            <div class='card-header text-bg-primary'>
                Primary
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

         <div class='card mb-3 border-success'>
            <div class='card-header text-bg-success'>
                Success
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-info'>
            <div class='card-header text-bg-info'>
                Info
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-warning'>
            <div class='card-header text-bg-warning'>
                Warning
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-danger'>
            <div class='card-header text-bg-danger'>
                Danger
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-secondary'>
            <div class='card-header text-bg-secondary'>
                Secondary
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-light'>
            <div class='card-header text-bg-light'>
                Light
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        <div class='card mb-3 border-dark'>
            <div class='card-header text-bg-dark'>
                Dark
            </div>
            <div class='card-body'>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </div>           
        </div>

        
    </div>
</div>